module.exports = __webpack_public_path__ + "img/detail8.aae6988e.jpg";